export default __webpack_public_path__ + "static/media/background.e531fe7e.jpg";